import { DefaultValueResolver } from '../default-value-resolver';

/**
 * Represents a default value resolver.
 * 
 * @type {DefaultValueResolver}
 */
export const DEFAULT_VALUE_RESOLVER: DefaultValueResolver = () => undefined;
